function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { cmsActions } from '../../reducers/cms.reducer';
import useHasPermission from '../../helpers/hooks/useHasPermission';
import SubHeader from '../header/SubHeader.react';
import ConstruxHeader from '../header/ConstruxHeader.react';
import PparkHeader from '../header/PparkHeader.react';
import NavigationEdit from '../navigation/NavigationEdit.react';
import ArticlesTable from '../articles/ArticlesTable.react';
import AccessRestricted from '../app/routing/AccessRestricted.react';
import LastArticles from './LastArticles.react';
var ProjectDashboard = function ProjectDashboard(_ref) {
  var navigationAction = _ref.navigationAction;
  var _useParams = useParams(),
    app = _useParams.app,
    itemID = _useParams.itemID;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    page = _useState2[0],
    setPage = _useState2[1];
  useEffect(function () {
    navigationAction({});
  }, []);
  var cmsNavigation = useSelector(function (s) {
    return s.cms.navigation || {};
  });
  var cmsPages = useSelector(function (s) {
    return s.pos.pages || {};
  });
  useEffect(function () {
    if (!itemID || !cmsNavigation[itemID]) setPage(null);else setPage(Object.values(cmsPages).find(function (x) {
      return x.internalUrl === cmsNavigation[itemID].internalUrl;
    }) || null);
  }, [app, itemID, cmsNavigation, cmsPages]);
  if (!useHasPermission("view-".concat(app))) return /*#__PURE__*/React.createElement(AccessRestricted, null);
  var getNavBarArr = function getNavBarArr() {
    switch (app) {
      case 'posillico':
        return ['header', 'footer'];
      case 'materials':
      case 'washplant':
      case 'construx':
        return ['header'];
      case 'ppark':
        return ['header-top', 'header-bottom'];
      default:
        return [];
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SubHeader, {
    route: "dashboard"
  }), app === 'construx' && /*#__PURE__*/React.createElement(ConstruxHeader, {
    route: "dashboard"
  }), app === 'ppark' && /*#__PURE__*/React.createElement(PparkHeader, {
    route: "dashboard"
  }), /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, itemID && /*#__PURE__*/React.createElement(NavigationEdit, {
    route: "dashboard",
    navBarArr: getNavBarArr()
  }))));
};
var mdtp = {
  navigationAction: cmsActions.navigation
};
export default connect(null, mdtp)(ProjectDashboard);